import { Document, Page, View, StyleSheet, Text, Font, Image } from "@react-pdf/renderer";
// import imgKkp from '../../../assets/images/logo_kkp.jpg'
import srcArial from '../../../assets/custom/font/arial/arial.ttf'
import srcArialBold from '../../../assets/custom/font/arial/ARIBL0.ttf'
import { useEffect, useMemo, useState } from "react";
import MasterService from "../../../services/master/MasterService";
import TransaksiService from "../../../services/transaksi/TransaksiService";
import { formatDateStringDateFirst } from "../../../utilities/Utils";
import imgCheck from "../../../assets/images/icons/check.png"
import Pegawai from "../../../utilities/Pegawai";
import JenisProduk from "../../../utilities/JenisProduk";

// import srcTimes from '../../../assets/custom/font/times/times.ttf'
// import srcTimesBold from '../../../assets/custom/font/times/timesbd.ttf'
// import srcTimesItalic from '../../../assets/custom/font/times/timesi.ttf'
// import UPT from "../../../utilities/UPT";
// import ttdImg from "../../../assets/images/ttd_basah.JPG"

Font.register({ family: 'Arial', src: srcArial })
Font.register({ family: 'Arial-Bold', src: srcArialBold })
// Font.register({ family: 'Times', src: srcTimes })
// Font.register({ family: 'Times', src: srcTimesBold })
// Font.register({ family: 'Times-Bold', src: srcTimesBold })

// Font.register({ family: 'Roboto-Italic', src: srcRobotoItalic })

const styles = StyleSheet.create({
    page: {
        paddingTop: 20,
        paddingBottom: 48,
        paddingHorizontal: 42,
        boxSizing: "border-box"
    },
    headingImg: {
        width: 115,
        height: 100,
    },
    headingTtd: {
        width: 189,
        height: 123,
    },
    table: {
        display: "table",
        width: "auto"
    },
    tableRow: {
        flexDirection: "row",
        flexWrap: "wrap"
    },
    tableCol: {
        // border: '0 solid black',
        borderWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        borderRightWidth: 0,
        borderBottomWidth: 0,
        padding: 1
    },
    text: {
        fontSize: 10,
        // fontFamily: "Arial"
        fontFamily: "Arial"
    },
    textBold: {
        fontSize: 12,
        fontFamily: "Arial-Bold"
    },
    checkIcon: {
        width: 12,
        height: 12
    }
})

const DraftLHEvaluasi = ({ dataDisposisi, datappm }) => {

    const [listKomponenVerlap, setListKomponenVerlap] = useState([])
    const [stsRadioValues, setStsRadioValues] = useState({})
    const [ppmMutu, setPpmMutu] = useState(null)
    const [hasilEv, setHasilEv] = useState(null)

    let masterService = useMemo(() => new MasterService(), [])
    let transaksiService = useMemo(() => new TransaksiService(), [])

    useEffect(() => {
        const getListKomponenVerlap = async () => {
            try {
                const response = await masterService.listKomponenVerlap(0, 20)
                setListKomponenVerlap(response.data.data)
            } catch (error) {
                console.log(error)
            }
        }
        getListKomponenVerlap()
    }, [masterService])

    useEffect(() => {
        if (!dataDisposisi) return
        const getSpp = async () => {
            try {
                const resPpmMutu = await transaksiService.getPpmMutuById(datappm.nomorAju)
                setPpmMutu(resPpmMutu.data)

                const resHasilEv = await transaksiService.listHasilVerLapangan(0, datappm.nomorAju, 0, 1)

                let hasilEvPermohonan = resHasilEv.data.data[0]
                setStsRadioValues({ '1006': hasilEvPermohonan.stsProduk, '1005': hasilEvPermohonan.stsSpecies })

                let kesimpulan = { idKesimpulan: hasilEvPermohonan.idKesimpulan, kesimpulan: hasilEvPermohonan.kseimpulan }
                setValueKesimpulanOpt(kesimpulan)

                // console.log(resHasilEv.data.data[0])

                setHasilEv(resHasilEv.data.data[0])
            } catch (error) {
                // console.log(error)
                // setListPenugasanDetil([])
                // setHasilEv(null)
            }
        }
        getSpp()
    }, [transaksiService, dataDisposisi, datappm])

    const [valueKesimpulanOpt, setValueKesimpulanOpt] = useState(null)

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={[styles.table, { marginTop: 35, marginBottom: 20 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '100%', alignItems: 'center' }]}>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: 'center' }]}>FORM HASIL EVALUASI TEKNIS</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { marginBottom: 10 }]}>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '5%', alignItems: 'left' }]}>
                        </View>
                        <View style={[styles.tableCol, { width: '25%', alignItems: 'left' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Tanggal Permohoanan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '67%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{datappm !== null ? formatDateStringDateFirst(datappm.tanggalAju) : ''}</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '5%', alignItems: 'left' }]}>
                        </View>
                        <View style={[styles.tableCol, { width: '25%', alignItems: 'left' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>No Agenda</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '67%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{dataDisposisi !== null ? dataDisposisi.noTugas : ''}</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '5%', alignItems: 'left' }]}>
                        </View>
                        <View style={[styles.tableCol, { width: '25%', alignItems: 'left' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Nama Unit Usaha</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '67%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{datappm !== null ? datappm.namaTrader : ''}</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '5%', alignItems: 'left' }]}>
                        </View>
                        <View style={[styles.tableCol, { width: '25%', alignItems: 'left' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Alamat</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '67%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{datappm !== null ? datappm.alamatTrader : ''}</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '5%', alignItems: 'left' }]}>
                        </View>
                        <View style={[styles.tableCol, { width: '25%', alignItems: 'left' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Jenis Produk</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '67%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{ppmMutu !== null ? <JenisProduk id={ppmMutu.mutuJnsProduk} /> : ''}</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { marginBottom: 10 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '5%' }]}>
                            {/* <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Dasar</Text> */}
                        </View>
                        <View style={[styles.tableCol, { width: '5%', borderTopWidth: 1, borderLeftWidth: 1, alignItems: 'center' }]}>
                            <Text style={[styles.text, { fontSize: 11, textAlign: 'center' }]}>No</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%', borderTopWidth: 1, borderLeftWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 11, textAlign: 'center' }]}>Kesesuaian Dokumen Permohonan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '10%', borderTopWidth: 1, borderLeftWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 11, textAlign: 'center' }]}>Sesuai</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '10%', borderTopWidth: 1, borderLeftWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 11, textAlign: 'center' }]}>Tidak Sesuai</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '25%', borderTopWidth: 1, borderLeftWidth: 1, borderRightWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 11, textAlign: 'center' }]}>Keterangan</Text>
                        </View>
                    </View>
                    {
                        listKomponenVerlap !== null && listKomponenVerlap.map((komp, index) => {
                            return (
                                <>
                                    <View key={index} style={styles.tableRow}>
                                        <View style={[styles.tableCol, { width: '5%' }]}>
                                        </View>
                                        <View style={[styles.tableCol, { width: '5%', borderTopWidth: 1, borderLeftWidth: 1, borderBottomWidth: 1 }]}>
                                            <Text style={[styles.text, { fontSize: 11, textAlign: 'center' }]}>{index + 1}</Text>
                                        </View>
                                        <View style={[styles.tableCol, { width: '40%', borderTopWidth: 1, borderLeftWidth: 1, borderBottomWidth: 1 }]}>
                                            <Text style={[styles.text, { fontSize: 11, textAlign: 'left' }]}>{komp.komponen}</Text>
                                        </View>
                                        <View style={[styles.tableCol, { width: '10%', borderTopWidth: 1, borderLeftWidth: 1, borderBottomWidth: 1 }]}>
                                            <Text style={[styles.text, { fontSize: 11, textAlign: 'center' }]}>
                                                {
                                                    stsRadioValues[komp.tipe] === '1' ?
                                                        <>
                                                            <Image src={imgCheck} style={styles.checkIcon} />
                                                        </>
                                                        :
                                                        <>
                                                        </>
                                                }
                                            </Text>
                                        </View>
                                        <View style={[styles.tableCol, { width: '10%', borderTopWidth: 1, borderLeftWidth: 1, borderBottomWidth: 1 }]}>
                                            <Text style={[styles.text, { fontSize: 11, textAlign: 'center' }]}>
                                                {
                                                    stsRadioValues[komp.tipe] === '0' ?
                                                        <>
                                                            <Image src={imgCheck} style={styles.checkIcon} />
                                                        </>
                                                        :
                                                        <>
                                                        </>
                                                }
                                            </Text>
                                        </View>
                                        <View style={[styles.tableCol, { width: '25%', borderTopWidth: 1, borderLeftWidth: 1, borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                            <Text style={[styles.text, { fontSize: 11, textAlign: 'left' }]}></Text>
                                        </View>
                                    </View>
                                </>
                            )
                        })
                    }
                </View>
                <View style={[styles.table, { marginBottom: 10 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '5%' }]}>
                            {/* <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Keterangan : Beri tandan LHU Pengujian</Text> */}
                        </View>
                        <View style={[styles.tableCol, { width: '90%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>REKOMENDASI</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { marginBottom: 10 }]}>
                    <View style={[styles.tableRow, { marginBottom: 5 }]}>
                        <View style={[styles.tableCol, { width: '5%' }]}>
                            {/* <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Dasar</Text> */}
                        </View>
                        <View style={[styles.tableCol, { width: '5%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>1.</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '30%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Dapat diterbitkan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '8%', borderTopWidth: 1, borderLeftWidth: 1, borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>
                                {
                                    valueKesimpulanOpt !== null && valueKesimpulanOpt.idKesimpulan === '4' ?
                                        <>
                                            <Image src={imgCheck} style={styles.checkIcon} />
                                        </>
                                        :
                                        <>
                                        </>

                                }
                            </Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '5%' }]}>
                            {/* <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Dasar</Text> */}
                        </View>
                        <View style={[styles.tableCol, { width: '5%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>2.</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '30%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Tidak dapat diterbitkan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '8%', borderTopWidth: 1, borderLeftWidth: 1, borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>
                                {
                                    valueKesimpulanOpt !== null && valueKesimpulanOpt.idKesimpulan === '5' ?
                                        <>
                                            <Image src={imgCheck} style={styles.checkIcon} />
                                        </>
                                        :
                                        <>
                                        </>

                                }
                            </Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { marginBottom: 10 }]}>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '35%' }]}>
                            {/* <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Dasar</Text> */}
                        </View>
                        <View style={[styles.tableCol, { width: '25%', borderTopWidth: 1, borderLeftWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Petugas Evaluasi</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%', borderTopWidth: 1, borderLeftWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '35%', borderTopWidth: 1, borderLeftWidth: 1, borderRightWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'center' }]}>{hasilEv !== null ? <Pegawai id={hasilEv.nipInspektur} /> : ''}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '35%' }]}>
                            {/* <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Dasar</Text> */}
                        </View>
                        <View style={[styles.tableCol, { width: '25%', borderTopWidth: 1, borderLeftWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Tanggal</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%', borderTopWidth: 1, borderLeftWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '35%', borderTopWidth: 1, borderLeftWidth: 1, borderRightWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'center' }]}>{hasilEv !== null ? formatDateStringDateFirst(hasilEv.dateCreate) : ''}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '35%' }]}>
                            {/* <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Dasar</Text> */}
                        </View>
                        <View style={[styles.tableCol, { width: '25%', borderTopWidth: 1, borderLeftWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Paraf</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%', borderTopWidth: 1, borderLeftWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '35%', borderTopWidth: 1, borderLeftWidth: 1, borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            {/* <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>Petugas Verifikator</Text> */}
                        </View>
                    </View>
                </View>
            </Page>
        </Document>
    )
}

export default DraftLHEvaluasi